<!-- 
<h2 mat-dialog-title>Report</h2> -->
<mat-dialog-content class="dialog-scroll-content">    
    <app-report-details [ReportId]="data.ReportId" ></app-report-details>
    
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-raised-button [mat-dialog-close]="true" cdkFocusInitial>CLOSE</button>
    @if(data.CanEdit){
        <button mat-raised-button [mat-dialog-close]="true"  [routerLink]="['/scouting/editreport', data.ReportId]" cdkFocusInitial>EDIT</button>
    }
    
    
</mat-dialog-actions>
